module.exports = __webpack_public_path__ + "images/info@3x.png?86804022";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/info@3x.png
// module id = 674
// module chunks = 7